import Navbar from "../DashboardNavbar";
import Sidebar from "../Sidebar";

const Layout = ({ children }) => {
  return (
    <div
      className="layout"
      style={{ display: "flex", flexDirection: "column", height: "100vh" }}
    >
      <div
        className="navbarStyle"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1200,
          height: "64px",
        }}
      >
        <Navbar />
      </div>

      <div
        className="otherPage"
        style={{
          display: "flex",
          marginTop: "64px",
          height: "calc(100vh - 64px)",
        }}
      >
        <div style={{ flexShrink: 0 }}>
          <Sidebar />
        </div>

        <div
          className="pages"
          style={{
            flexGrow: 1,
            overflow: "auto",
            padding: "16px",
          }}
        >
          {children}
        </div>
      </div>

      <div></div>
    </div>
  );
};

export default Layout;
